import { render } from "./Assistant.vue?vue&type=template&id=3f11a65d"
import script from "./Assistant.vue?vue&type=script&lang=js"
export * from "./Assistant.vue?vue&type=script&lang=js"

import "./Assistant.vue?vue&type=style&index=0&id=3f11a65d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__